import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type WeddingBalloonsIconProps = CreateIconComponentProps;
export const WeddingBalloonsIcon: React.FC<WeddingBalloonsIconProps> = ({
  title = 'WeddingBalloons',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 14C5.512 8.24 5.79 5.563 6.16 4.357a3.313 3.313 0 0 1 5.845-1.005 3.313 3.313 0 0 1 5.834 1.016c.372 1.201.65 3.872-5.838 9.632Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M14 12.5c.667.833 2.2 2.5 3 2.5 1-.167 3.3-1.3 4.5-4.5C23 6.5 19.5 4 18 4M9.866 12.5c-.667.833-2.2 2.5-3 2.5-1-.167-3.3-1.3-4.5-4.5-1.5-4 2-6.5 3.5-6.5"
    />
    <path
      fill="currentColor"
      d="M16 22a1 1 0 1 0 2 0h-2Zm0-4v4h2v-4h-2ZM6 22a1 1 0 1 0 2 0H6Zm0-4v4h2v-4H6ZM11 22a1 1 0 1 0 2 0h-2Zm0-6v6h2v-6h-2Z"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11.5 14h1l.5 1h-2l.5-1ZM6.5 16h1l.5 1H6l.5-1ZM16.5 16h1l.5 1h-2l.5-1Z"
    />
  </CreateIconComponent>
);
